import { render } from "./OtpInput.vue?vue&type=template&id=00f9f8c1&scoped=true"
import script from "./OtpInput.vue?vue&type=script&lang=js"
export * from "./OtpInput.vue?vue&type=script&lang=js"

import "./OtpInput.vue?vue&type=style&index=0&id=00f9f8c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f9f8c1"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QField});
